import React, { useState, useEffect } from 'react'
import { StockValueTableView } from './StockValueTableView'
import axios from 'axios'

export const StockValueTable = () => {
    const [products, setProducts] = useState()
    const [loading, setLoading] = useState(true)
    const [brands, setBrands] = useState()
    const [suppliers, setSuppliers] = useState()
    const [categories, setCategories] = useState()
    const [updated, setUpdated] = useState([])
    const [filteredTotalQuantity, setFilteredTotalQuantity] = useState(0)
    const [filteredTotalCost, setFilteredTotalCost] = useState(0)
    const [filteredResult, setNewFilteredResult] = useState([])
    const [sortedResult, setSortedResult] = useState([])
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        axios.get(process.env.REACT_APP_HOST + 'api/reports/getProducts')
            .then((res) => {
                setBrands(res.data.brands)
                setSuppliers(res.data.suppliers)
                setCategories(res.data.categories)
                setProducts(res.data.products)
              

                return res.data.products
            }).then((data) => {
                //filter so only shows top level parent products, avoids duplication in tagging
                const arr = []
                const masterIdObj = {}
                let results = data.filter((product) => {
                    product.subProducts = []

                    //single sku products
                    if (product.parentId === '') {
                        return product
                        //if first instance of a multiple
                    } else if (!arr.includes(product.parentId)) {
                        arr.push(product.parentId)
                        masterIdObj[product.parentId] = product.id
                        const productIdToAddTo = masterIdObj[product.parentId]
                        const index = data.findIndex(x => x.id === productIdToAddTo)
                        data[index].subProducts.push(product)
                        return product
                        //if subsequent instance of a multiple, add additional to subproducts array
                    } else if (arr.includes(product.parentId)) {
                        const productIdToAddTo = masterIdObj[product.parentId]
                        const index = data.findIndex(x => x.id === productIdToAddTo)
                        data[index].subProducts.push(product)
                    }

                })
                results = addTotals(results)

                setProducts(results)
                setNewFilteredResult(results)
                setLoading(false)

            })

    }, [])

    const addTotals = (products) => {
        products.forEach((product) => {
            //add single product totals
            product.totalQuantity = 0
            product.totalCost = 0
            if (product.subProducts.length === 0) {
                product.totalCost = product.productCost * product.qtyByDate[product.qtyByDate.length - 1][0][1] 
                product.totalQuantity = product.qtyByDate[product.qtyByDate.length - 1][0][1]
                product.totalThirtyDaySales = product.thirtyDaySales
                product.totalSixtyDaySales = product.sixtyDaySales

            } else {
                //add multiple product totals
                product.totalThirtyDaySales = 0
                product.totalSixtyDaySales = 0
                product.subProducts.forEach((subProduct) => {
                    if (subProduct.qtyByDate[product.qtyByDate.length - 1] !== undefined) {
                        const quantity = subProduct.qtyByDate[product.qtyByDate.length - 1][0][1]
                        product.totalQuantity += quantity
                        product.totalCost += (quantity * subProduct.productCost)
                        product.totalThirtyDaySales += Number(subProduct.thirtyDaySales)
                        product.totalSixtyDaySales += Number(subProduct.sixtyDaySales)

                    }
                 
                })
               
            }


        })
        const totalQuantity = products.reduce((acc, x) => acc += x.totalQuantity, 0)
        const totalCost = products.reduce((acc, x) => acc += x.totalCost, 0)
        setFilteredTotalQuantity(totalQuantity)
        setFilteredTotalCost(totalCost)
        return products
    }



    const onClickSubmit = (row) => {
        axios.post(process.env.REACT_APP_HOST + 'api/reports/update', {
            params: {
                product: row
            }
        }).then((res) => {
            if (res.data.modifiedCount === 1) {
                setUpdated(...updated, row.id)
            }
        })
    }



    return <StockValueTableView
        loading={loading}
        products={products}
        brands={brands}
        suppliers={suppliers}
        categories={categories}
        onClickSubmit={onClickSubmit}
        updated={updated}
        setFilteredTotalCost={setFilteredTotalCost}
        setFilteredTotalQuantity={setFilteredTotalQuantity}
        filteredTotalCost={filteredTotalCost}
        filteredTotalQuantity={filteredTotalQuantity}
        setNewFilteredResult={setNewFilteredResult}
        filteredResult={filteredResult}
        sortedResult={sortedResult}
        setSortedResult={setSortedResult}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}

    />
}

